import { useWatch } from 'react-hook-form';

import { formatHours } from '../../EmploymentHours.utils';
import { toDisplayValue } from '../HoursCorrectionDialog/hoursCorrection.utils';

type Props = {
  /** `hoursBalanceBase`, in stored space */
  base?: number;
  showPlusMinus: boolean;
};

/**
 * `allHoursWorkTotal` is not in the payload — Dojo computed it in the correction form
 * (`EmployeeHoursCorrectionViewModel.js:39-50`) as base + correction, negating the correction under
 * the plus/minus preference. Both operands are held in display space here, and negation is linear, so
 * the branch collapses to plain addition.
 *
 * Its own component so a keystroke in the correction field re-renders this one cell, not the ~85 rows
 * of the window.
 */
const TotalHoursValue = ({ base, showPlusMinus }: Props) => {
  'use memo';

  const correction = useWatch({ name: 'inputWorkingHoursCor' }) as
    | number
    | ''
    | null;
  const displayBase = toDisplayValue(base, showPlusMinus);

  // an untouched or cleared input is '' or null; Number('') is 0, Number(null) is 0
  return <>{formatHours((displayBase ?? 0) + Number(correction ?? 0))}</>;
};

export default TotalHoursValue;
